"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isInviteItem(object) {
    return checkInviteItem(object).fulfilled;
}
exports.isInviteItem = isInviteItem;
function checkInviteItem(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasNumber("timestamp"), Check_1.hasBoolean("emailSent"), Check_1.hasString("projectId"), Check_1.hasString("projectName")).withOptions(options).explain();
}
exports.checkInviteItem = checkInviteItem;
//# sourceMappingURL=InviteItem.js.map